import { lazy, Suspense } from 'react'
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import { AppShell, RequireAuth } from './layout/AppShell'
import './index.css'

const LandingPage = lazy(() => import('./pages/LandingPage').then(m => ({ default: m.LandingPage })))
const LoginPage = lazy(() => import('./pages/LoginPage').then(m => ({ default: m.LoginPage })))
const RegisterPage = lazy(() => import('./pages/RegisterPage').then(m => ({ default: m.RegisterPage })))
const OrdersPage = lazy(() => import('./pages/OrdersPage').then(m => ({ default: m.OrdersPage })))
const ProductsPage = lazy(() => import('./pages/ProductsPage').then(m => ({ default: m.ProductsPage })))
const CategoriesPage = lazy(() => import('./pages/CategoriesPage').then(m => ({ default: m.CategoriesPage })))
const DashboardPage = lazy(() => import('./pages/DashboardPage').then(m => ({ default: m.DashboardPage })))
const OrderHistoryPage = lazy(() => import('./pages/OrderHistoryPage').then(m => ({ default: m.OrderHistoryPage })))
const StaffPage = lazy(() => import('./pages/StaffPage').then(m => ({ default: m.StaffPage })))
const KeysPage = lazy(() => import('./pages/KeysPage').then(m => ({ default: m.KeysPage })))
const ThemePage = lazy(() => import('./pages/ThemePage').then(m => ({ default: m.ThemePage })))
const TaxPage = lazy(() => import('./pages/TaxPage').then(m => ({ default: m.TaxPage })))
const TipsPage = lazy(() => import('./pages/TipsPage').then(m => ({ default: m.TipsPage })))
const BillingPage = lazy(() => import('./pages/BillingPage').then(m => ({ default: m.BillingPage })))
const SettingsPage = lazy(() => import('./pages/SettingsPage').then(m => ({ default: m.SettingsPage })))

function PageLoader() {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '60vh', gap: '0.75rem', color: '#64748b' }}>
      <div style={{
        width: '32px',
        height: '32px',
        border: '3px solid #e2e8f0',
        borderTopColor: '#0ea5e9',
        borderRadius: '50%',
        animation: 'spin 0.8s linear infinite'
      }} />
      <span style={{ fontSize: '0.88rem', fontWeight: 500, color: '#64748b' }}>Loading…</span>
    </div>
  )
}

export default function App() {
  return (
    <BrowserRouter>
      <Suspense fallback={<PageLoader />}>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route element={<RequireAuth />}>
            <Route element={<AppShell />}>
              <Route path="orders" element={<OrdersPage />} />
              <Route element={<RequireAuth ownerOnly />}>
                <Route path="products" element={<ProductsPage />} />
                <Route path="categories" element={<CategoriesPage />} />
                <Route path="import" element={<Navigate to="/products" replace />} />
                <Route path="dashboard" element={<DashboardPage />} />
                <Route path="history" element={<OrderHistoryPage />} />
                <Route path="staff" element={<StaffPage />} />
                <Route path="keys" element={<KeysPage />} />
                <Route path="theme" element={<ThemePage />} />
                <Route path="taxes" element={<TaxPage />} />
                <Route path="tips" element={<TipsPage />} />
                <Route path="billing" element={<BillingPage />} />
                <Route path="settings" element={<SettingsPage />} />
              </Route>
            </Route>
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  )
}
